import { observable, action, computed } from "mobx";

import { merge } from "lodash";

import fr from "./fr.json";
import en from "./en.json";
import it from "./it.json";

import countriesStore from "../countriesStore";

class TranslationsStore {
  // variables
  @observable currentLanguage;
  @observable currentTranslation;
  @observable longDateFormat;

  constructor() {
    this.translations = { en, fr, it };

    // Italian, English, French
    this.translations.en = merge({}, this.translations.it, this.translations.en);
    this.translations.fr = merge({}, this.translations.en, this.translations.fr);

    this.currentTranslation = {};
    this.countriesStore = countriesStore;
  }

  @action
  setLanguage = lan => {
    this.currentLanguage = lan.substring(0, 2);
    localStorage.setItem("currentLanguage", this.currentLanguage);
    this.setTranslation();
    this.countriesStore.setCountries(this.currentLanguage);
  };

  @action
  setTranslation = () => {
    this.currentTranslation = this.translations[this.currentLanguage];
  };

  @computed.struct
  get current() {
    return this.currentTranslation;
  }

  @action
  setLongDateFormat(longDateFormat) {
    this.longDateFormat = longDateFormat;
  }
}

export default new TranslationsStore();



// WEBPACK FOOTER //
// ./src/stores/translations/index.js